var _NODES_NAMES$formula$;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { isNil, omit } from "lodash-es";
import { APP_NAME, NODE_TYPES, FormulaModel, TableModel, ChartModel, renderPlainTableAsDOM } from "@reactivepad/core";

export var NODES_NAMES = {
  formula: APP_NAME + "_" + NODE_TYPES.formula,
  table: APP_NAME + "_" + NODE_TYPES.table,
  chart: APP_NAME + "_" + NODE_TYPES.chart
};

export var NODES_DATA_ATTRS = {
  type: "data-" + APP_NAME + "-type",
  props: "data-" + APP_NAME + "-props"
};

var DEFAULT_ATTR_VALUE = null;

var mapPropertyNamesToAttrs = function mapPropertyNamesToAttrs(_ref) {
  var propertyNames = _ref.propertyNames;
  return propertyNames.reduce(function (acc, next) {
    var _extends2;

    return _extends({}, acc, (_extends2 = {}, _extends2[next] = { default: DEFAULT_ATTR_VALUE }, _extends2));
  }, {});
};

export var parsePropsFromAttrs = function parsePropsFromAttrs(el) {
  var propsToSkip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return omit(JSON.parse(el.getAttribute(NODES_DATA_ATTRS.props)), propsToSkip);
};

var querySelectorHelper = function querySelectorHelper(el, s) {
  return Array.from(el.querySelectorAll(s));
};

export var extractTablePropsFromAttrs = function extractTablePropsFromAttrs(table, withoutIdsAndRefs) {
  var props = parsePropsFromAttrs(table);

  if (!props.columns) {
    props.columns = querySelectorHelper(table, "thead th").map(function (th) {
      return parsePropsFromAttrs(th, withoutIdsAndRefs && "id");
    });
  }

  if (!props.rows) {
    props.rows = querySelectorHelper(table, "tbody tr").map(function (tr) {
      var rowProps = parsePropsFromAttrs(tr, withoutIdsAndRefs && "id");
      var cells = querySelectorHelper(tr, "td").map(function (td) {
        return parsePropsFromAttrs(td, withoutIdsAndRefs && ["id", "column"]);
      });

      return _extends({}, rowProps, {
        cells: cells
      });
    });
  }

  return props;
};

// ToDo: write tests that will ensure correctness of attrs
export default (_NODES_NAMES$formula$ = {}, _NODES_NAMES$formula$[NODES_NAMES.formula] = {
  attrs: mapPropertyNamesToAttrs(FormulaModel),
  inline: true,
  group: "inline",
  atom: true,
  // toDOM is used in copying (ctrl-c); parseDOM is used to bring back node
  toDOM: function toDOM(_ref2) {
    var _ref3;

    var attrs = _ref2.attrs;

    return ["span", (_ref3 = {}, _ref3[NODES_DATA_ATTRS.type] = NODE_TYPES.formula, _ref3[NODES_DATA_ATTRS.props] = JSON.stringify(attrs), _ref3), isNil(attrs.formatted) ? "#NULL!" : "" + attrs.formatted];
  },

  parseDOM: [{
    tag: "span[" + NODES_DATA_ATTRS.type + "=\"" + NODE_TYPES.formula + "\"]",
    getAttrs: function getAttrs(dom) {
      return parsePropsFromAttrs(dom);
    }
  }]
}, _NODES_NAMES$formula$[NODES_NAMES.table] = {
  attrs: mapPropertyNamesToAttrs(TableModel),
  group: "block",
  atom: true,
  isolating: true,
  selectable: false,
  draggable: false,
  toDOM: function toDOM(_ref4) {
    var attrs = _ref4.attrs;
    return renderPlainTableAsDOM(attrs);
  },
  parseDOM: [{
    tag: "table[" + NODES_DATA_ATTRS.type + "=\"" + NODE_TYPES.table + "\"]",
    getAttrs: function getAttrs(dom) {
      return extractTablePropsFromAttrs(dom);
    }
  }]
}, _NODES_NAMES$formula$[NODES_NAMES.chart] = {
  attrs: mapPropertyNamesToAttrs(ChartModel),
  group: "block",
  atom: true,
  isolating: true,
  selectable: false,
  draggable: false,
  toDOM: function toDOM() {
    return ["div", {}, "chart"];
  }, // ToDo: fix
  parseDOM: [{
    tag: "div[" + NODES_DATA_ATTRS.type + "=\"" + NODE_TYPES.chart + "\"]",
    getAttrs: function getAttrs(dom) {
      return parsePropsFromAttrs(dom);
    }
  }]
}, _NODES_NAMES$formula$);